import React from "react";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";

export function ZaunCircleMenuItemFlipElement({}) {
  const agt = APP.arrangement;
  const contract = () => {
    const elemente = agt.selectedObjects;
    return !elemente.some((e) => !e.isAnschluss);
  };
  if (!contract()) {
    return null;
  }
  const label = I18N("Anschlusselement umdrehen");
  return (
    <ZaunCircleMenuItem
      dataButtonKey={label}
      onClick={(event) => {
        event.stopPropagation();
        if (!contract()) {
          return null;
        }
        agt.selectedObjects.forEach((s) => (s.anschlussAufRechts = !s.anschlussAufRechts));
        APP.update3d();
        APP.logUserAction({ action: "flipAnschlussAufRechts" });
      }}
    >
      {label}
    </ZaunCircleMenuItem>
  );
}
